var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsletterOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.564,
    height: 16.851,
    viewBox: "0 0 20.564 16.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.856,5H19.708a2.86,2.86,0,0,1,2.856,2.856V18.995a2.86,2.86,0,0,1-2.856,2.856H4.856A2.86,2.86,0,0,1,2,18.995V7.856A2.86,2.86,0,0,1,4.856,5ZM19.708,19.851a.857.857,0,0,0,.856-.856V7.856A.857.857,0,0,0,19.708,7H4.856A.857.857,0,0,0,4,7.856V18.995a.857.857,0,0,0,.856.856Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.282,16.5a1,1,0,0,1-.573-.181l-9.282-6.5A1,1,0,0,1,3.573,8.181l8.709,6.1,8.709-6.1a1,1,0,0,1,1.147,1.638l-9.282,6.5A1,1,0,0,1,12.282,16.5Z",
    transform: "translate(0 -1.144)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterOn);
export default __webpack_public_path__ + "static/media/Newsletter-On.85035f11df1224497e6acc5f15005edf.svg";
export { ForwardRef as ReactComponent };